import { composeClasses } from '@/utils/compose-classes'

export interface TabsProps {
  /**
   * React node to display something inside de tabs
   * */
  children: React.ReactNode
  /**
   * ClassName for  the main container
   * */
  className?: string
}
export const Tabs = ({ children, className }: TabsProps) => {
  return (
    <div
      data-testid="tabs-container"
      className={composeClasses(
        'flex justify-start items-center h-14 w-full overflow-x-auto relative',
        className
      )}
    >
      {children}
    </div>
  )
}

export default Tabs
